import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@tanstack/react-query';
import { getFirebaseBackend } from 'helpers/firebaseHelper';
import { getInitials } from 'utils/getInitials';
import AvatarPlaceholder from 'assets/images/Avatar.svg';
import CurrentUserAvatar from './CurrentUserAvatar';
import { AvatarContainer } from './styles';

const UserAvatar = ({ userId, size, usePlaceholder = false }) => {
  const firebaseHelper = getFirebaseBackend();

  const userQuery = useQuery({
    queryKey: ['user', userId],
    queryFn: async () => {
      return await firebaseHelper.getUser(userId);
    },
    cacheTime: 1000 * 5,
    staleTime: 1000 * 5,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  const hasUser = Boolean(userQuery.data);
  const photoUrl = userQuery.data?.photoUrl;

  return (
    <AvatarContainer
      data-is-loading={userQuery.isLoading}
      data-has-photo={Boolean(photoUrl)}
      data-assigned={hasUser}
      style={{ height: size, width: size }}
    >
      {photoUrl ? (
        <img src={photoUrl} alt="" />
      ) : (
        !hasUser && usePlaceholder && <img src={AvatarPlaceholder} alt="" />
      )}
      {userQuery.data && (
        <span style={{ fontSize: `calc(${size} * 0.4)` }}>
          {getInitials(userQuery.data.name, userQuery.data.lastName)}
        </span>
      )}
    </AvatarContainer>
  );
};

UserAvatar.propTypes = {
  userId: PropTypes.string,
  size: PropTypes.string,
  usePlaceholder: PropTypes.bool,
};

UserAvatar.CurrentUser = CurrentUserAvatar;

export default UserAvatar;
